module.exports = __webpack_public_path__ + "assets/img/301.a06229f5.png";